import React from 'react';
import { Link } from 'react-router';
import classNames from 'classnames';
import ActiveStateTriangle from '~/sidebarNav/components/ActiveStateTriangle';
type ArtifactViewLinkProps = {
  title: string;
  subtab: string;
  baseUrl: string;
  activeTab: string;
};
const ArtifactViewLink: React.SFC<ArtifactViewLinkProps> = props => {
  let title = props.title,
    subtab = props.subtab || 'summary',
    baseUrl = props.baseUrl,
    activeTab = props.activeTab,
    isActive = subtab === activeTab,
    optionClasses = classNames({
      'grid__item push--col-1-6 col-3-4 pl--': true,
      'color--primary': isActive,
    }),
    url = baseUrl + '/' + subtab,
    target = '',
    activeTriangle = isActive ? <ActiveStateTriangle /> : '';
  return (
    <Link
      className="pv-- mb-- grid grid--full cursor--pointer block position--relative link--no-underline"
      target={target}
      to={url}
    >
      <div className={optionClasses}>
        <div className="flex flex--justify-content--space-between flex--align-items--center">
          {title}
        </div>
      </div>
      {activeTriangle}
    </Link>
  );
};
export default ArtifactViewLink;
